import Vue from "vue";

Vue.component("annex-entities", {
    props: ["annexId", "empty"],
    data() {
        return {
            loading: false,
            entities: [],
            isEmpty: this.empty
        };
    },
    methods: {
        getByAnnexId() {
            const self = this;

            self.loading = true;
            self.$services.entities.getByAnnexId({
                annexId: self.annexId,
                language: window.currentLanguage,
                treeview: true
            }).then((data) => {
                self.loading = false;
                self.entities = data;
                self.isEmpty = data.length <= 0;
                self.$emit('update:empty', self.isEmpty);
            });
        }
    },
    mounted() {
        this.getByAnnexId();
    },
    template: `
		<div class="annex-entities">
			<template v-if="loading"><loading></loading></template>
			<template v-else>				
				<entities-treeview :data="entities"></entities-treeview>												
			</template>                        
		</div>
	`
});